// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3rX7N","clinicsSelect":"TableHeading_clinicsSelect__3-Y69"};